export const EVENT_NAME = {
  // GA events: https://support.google.com/analytics/answer/9322688
  SELECT_CONTENT: 'select_content',
  FILE_DOWNLOAD: 'file_download',
  CUSTOM: {
    ANNOUNCEMENT_OCCURRENCE: 'announcement_occurrence',
    ANNOUNCEMENT_CLOSE: 'announcement_close',
    ANNOUNCEMENT_READ: 'announcement_read',

    CLASSROOM_HEARTBEAT: 'heartbeat',
    CLASSROOM_TRY_INVALID_ACTION: 'try_invalid_action',
    CLASSROOM_SUBSECTION_VIDEO_COMPLETE: 'subsection_video_complete',
    CLASSROOM_SUBSECTION_VIDEO_COMPLETE_CLIENT: 'subsection_video_complete_client',
    CLASSROOM_SUBSECTION_CLICKED: 'subsection_clicked',
    CLASSROOM_SUBSECTION_CONTENT_CLICKED: 'subsection_content_clicked',
    CLASSROOM_SUBSECTION_VIDEO_COMPLETE_ERROR: 'subsection_video_complete_error',
    CLASSROOM_SUBSECTION_VIDEO_ON_VIDEO_PLAYER_ERROR: 'subsection_video_on_video_player_error',
    CLASSROOM_SUBSECTION_VIDEO_INTERACTION: 'classroom_subsection_video_interaction',

    QUIZ_START: 'quiz_start',
    QUIZ_SUBMIT: 'quiz_submit',
    QUIZ_SUBMIT_ERROR: 'quiz_submit_error',
    QUIZ_START_ERROR: 'quiz_start_error',

    MYPATH_CLICKED: 'mypath_click',

    FAQ_OPEN_PANEL: 'faq_open_panel',
    FAQ_CLOSE_PANEL: 'faq_close_panel',
    FAQ_ITEM_CLICKED: 'faq_item_clicked',
    FAQ_ITEM_BACK_BUTTON_CLICKED: 'faq_item_back_button_clicked',
    FAQ_VOTE_ITEM: 'faq_vote_item',
    FAQ_OPEN_CLEAR: 'faq_open_clear',
    FAQ_SUBMITTED_CLEAR_TICKET: 'faq_submitted_clear_ticket',
  },
};

export const CONTENT_GROUP = {
  POPUP_ANNOUNCEMENT: 'popup_announcement',
  NOTIFICATION: 'notification',
  CLASSROOM: 'classroom',
  QUIZ: 'quiz',
  MYPATH: 'mypath',
  FAQ: 'faq',
};
